import { apiService } from './api';

export interface DashboardStats {
  totalAppointments: {
    value: string;
    change: string;
    changeType: 'positive' | 'negative';
  };
  activePatients: {
    value: string;
    change: string;
    changeType: 'positive' | 'negative';
  };
  transcriptionsToday: {
    value: string;
    change: string;
    changeType: 'positive' | 'negative';
  };
  recordingTime: {
    value: string;
    change: string;
    changeType: 'positive' | 'negative';
  };
}

export interface RecentAppointment {
  id: string;
  patient: string;
  patientId: string;
  date: string;
  time: string;
  type: string;
  status: string;
  transcriptionStatus: string;
  provider: string;
}

export interface SystemStatus {
  transcriptionService: {
    status: 'online' | 'offline' | 'degraded';
    message: string;
    pendingJobs?: number;
  };
  database: {
    status: 'online' | 'offline';
    message: string;
  };
  encryption: {
    status: 'online' | 'offline';
    message: string;
  };
}

export interface DashboardData {
  stats: DashboardStats;
  recentAppointments: RecentAppointment[];
  generatedAt: string;
}

class DashboardService {
  private baseUrl = '/v1/dashboard';

  /**
   * Get dashboard statistics
   */
  async getStats(): Promise<DashboardData> {
    const response = await apiService.get<{ success: boolean; data: DashboardData }>(`${this.baseUrl}/stats`);
    return response.data;
  }

  /**
   * Get system status information
   */
  async getSystemStatus(): Promise<SystemStatus> {
    const response = await apiService.get<{ success: boolean; data: SystemStatus }>(`${this.baseUrl}/system-status`);
    return response.data;
  }

  /**
   * Refresh dashboard data (useful for real-time updates)
   */
  async refreshData(): Promise<{
    dashboardData: DashboardData;
    systemStatus: SystemStatus;
  }> {
    const [dashboardData, systemStatus] = await Promise.all([
      this.getStats(),
      this.getSystemStatus()
    ]);

    return {
      dashboardData,
      systemStatus
    };
  }
}

export const dashboardService = new DashboardService();